const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](.*))?$/;
const HAS_ZONE = /(?:Z|[+-]\d{2}(?::?\d{2})?)$/i;
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function format(day: number, month: number, year: number): string {
  return `${day} ${MONTHS[month]} ${year}`;
}

/**
 * A date as "1 Feb 2026" when it is a real calendar date; any other text (free text, an impossible
 * date) as sent; null stays null. A date-time with a zone shows its UTC day; one with no zone keeps
 * the day it was written with, whatever the machine's time zone.
 */
export function sourceDataDate(value: string | null): string | null {
  if (value === null) return null;
  const match = ISO_DATE.exec(value);
  if (!match) return value;

  const [, year, month, day, time] = match;
  const writtenDay = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  const isRealDay =
    writtenDay.getUTCFullYear() === Number(year) &&
    writtenDay.getUTCMonth() === Number(month) - 1 &&
    writtenDay.getUTCDate() === Number(day);
  if (!isRealDay) return value;

  if (time === undefined || !HAS_ZONE.test(time)) {
    return format(writtenDay.getUTCDate(), writtenDay.getUTCMonth(), writtenDay.getUTCFullYear());
  }

  const instant = new Date(value);
  if (Number.isNaN(instant.getTime())) return value;
  return format(instant.getUTCDate(), instant.getUTCMonth(), instant.getUTCFullYear());
}
